module.exports = __webpack_public_path__ + "static/media/Artikal3.f5233153.png";